module.exports = __webpack_public_path__ + "media/pages/book/components/images/platform-icons/ios-a8cfedb236d49c26c7352432ad9ecf41.svg";